<div nxLayout="grid maxwidth" class="insured-trips">
    <div nxRow>
        <div nxCol="12">
            <nx-link class="go-back">
                <a routerLink="../">
                    <nx-icon name='chevron-left'></nx-icon>
                    {{'policy.insured-trips.go-back' | translate}}
                </a>
            </nx-link>
        </div>
    </div>
    <div nxRow>
        <div nxCol="12">
            <nx-card>
                <nx-card-header class="header-action">
                    <h3 nxHeadline="subsection-medium" translate class="title">
                        policy.insured-trips.title</h3>
                    <cpc-button size="small-medium" [noHorizontalMargin]="true" [noVerticalMargin]="true"
                        (click)="newInsuredTrip()"><span translate>policy.insured-trips.insure-new-btn</span>
                    </cpc-button>
                </nx-card-header>
                <div class="trip-content nx-margin-top-m">
                    <form [formGroup]="form" autocomplete="off">
                        <nx-error nxFormfieldError *ngIf="form?.errors?.dateFrom == 'greater'" translate>
                            <span translate>policy.insured-trips.error.misdate</span>
                        </nx-error>
                        <div nxRow>
                            <div nxCol="12,12,12,3">
                                <nx-formfield label="{{ 'policy.insured-trips.it-status.title' | translate }}">
                                    <nx-dropdown formControlName="statusId">
                                        <ng-template ngFor let-status="$implicit" [ngForOf]="dropdownValues|keyvalue">
                                            <nx-dropdown-item value="{{status.key}}">
                                                {{status.value | translate}}
                                            </nx-dropdown-item>
                                        </ng-template>
                                    </nx-dropdown>
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,3">
                                <nx-formfield label="{{ 'policy.insured-trips.data.it-number' | translate }}">
                                    <input nxInput formControlName="policyNumber" type="text" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,3">
                                <nx-formfield label="{{ 'policy.insured-trips.data.insured-person' | translate }}">
                                    <input nxInput formControlName="personSurname" type="text" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,3">
                                <nx-formfield
                                    label="{{ 'policy.insured-trips.data.insured-person-date-birth' | translate }}">
                                    <input nxInput formControlName="dateBirth" type="text" nxDatefield [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY"/>
                                    <span nxFormfieldHint>D.M.RRRR / DD.MM.RRRR</span>
                                </nx-formfield>
                            </div>
                        </div>

                        <div nxRow>
                            <div nxCol="12,12,12,3" *ngIf="!fromTo.checked">
                                <nx-formfield 
                                    label="{{ 'policy.insured-trips.data.start-insurance-date' | translate }}">
                                    <input nxInput formControlName="dateBegin" type="text" nxDatefield [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY"/>
                                    <span nxFormfieldHint>D.M.RRRR / DD.MM.RRRR</span>
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,3" *ngIf="fromTo.checked">
                                <nx-formfield
                                    label="{{ 'policy.insured-trips.data.start-insurance-date-from' | translate }}">
                                    <input nxInput formControlName="dateFrom" type="text" nxDatefield [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY"/>
                                    <span nxFormfieldHint>D.M.RRRR / DD.MM.RRRR</span>
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,3" *ngIf="fromTo.checked">
                                <nx-formfield
                                    label="{{ 'policy.insured-trips.data.start-insurance-date-to' | translate }}">
                                    <input nxInput formControlName="dateTo" type="text" nxDatefield [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY"/>
                                    <span nxFormfieldHint>D.M.RRRR / DD.MM.RRRR</span>
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,3" class="trip-actions" *ngIf="fromTo.checked">
                                <nx-checkbox class="nx-margin-bottom-s" formControlName="sortByPolicyNumber">
                                    {{ 'policy.insured-trips.data.sort-by-policy-number' | translate }}</nx-checkbox>
                            </div>

                            <div nxCol="12,12,12,2" class="trip-actions">
                                <nx-checkbox class="nx-margin-bottom-s" formControlName="fromToChecked" #fromTo>
                                    {{ 'policy.insured-trips.data.from-to' | translate }}</nx-checkbox>
                            </div>
                        </div>
                    </form>

                    <div nxRow class="mb-50">
                        <div nxCol="2">
                            <cpc-button size="small-medium" [noHorizontalMargin]="true" [noVerticalMargin]="true"
                                (click)="search()"><span translate>policy.insured-trips.search-btn</span>
                            </cpc-button>
                        </div>
                        <div nxCol="2">
                            <cpc-button size="small-medium" [noHorizontalMargin]="true" [noVerticalMargin]="true"
                                (click)="resetAll()"><span translate>policy.insured-trips.reset-btn</span>
                            </cpc-button>
                        </div>
                    </div>

                    <!-- check swipebar module -->
                    <div class="scroll-container">
                        <table nxTable class="nx-table--scrollable">
                            <thead>
                                <tr nxTableRow>
                                    <th nxHeaderCell>
                                        {{
                                            'policy.insured-trips.data.it-number'
                                            | translate }}
                                    </th>
                                    <th nxHeaderCell>
                                        {{
                                            'policy.insured-trips.data.module' |
                                            translate }}
                                    </th>
                                    <th nxHeaderCell>
                                        {{
                                            'policy.insured-trips.data.charge' |
                                            translate }}
                                    </th>
                                    <th nxHeaderCell>
                                        {{
                                            'policy.insured-trips.data.start-insurance-date'
                                            |
                                            translate }}
                                    </th>
                                    <th nxHeaderCell>
                                        {{
                                            'policy.insured-trips.data.end-insurance-date'
                                            |
                                            translate }}
                                    </th>
                                    <th nxHeaderCell>
                                        {{
                                            'policy.insured-trips.it-status.title'
                                            | translate }}
                                    </th>
                                    <th nxHeaderCell>
                                        {{
                                            'policy.insured-trips.data.premium'
                                            | translate }}
                                    </th>
                                    <th nxHeaderCell>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngIf="pageTableData.length == 0">
                                    <td height="100" translate>
                                        policy.insured-trips.data.empty
                                    </td>
                                </tr>
                                <tr nxTableRow *ngFor="let item of pageTableData">
                                    <td nxTableCell>{{item.policyNumber}}
                                    </td>
                                    <td nxTableCell>{{item.scheme}}</td>
                                    <td nxTableCell>{{item.rate |
                                            currencyFormat }}</td>
                                    <td nxTableCell>{{item.dateBegin |
                                            dateFormat}}</td>
                                    <td nxTableCell>{{item.dateEnd |
                                            dateFormat}}</td>
                                    <td nxTableCell>{{item.statusLabel}}
                                    </td>
                                    <td nxTableCell>{{item.premium |
                                            currencyFormat }}</td>

                                    <td nxTableCell *ngIf="item.statusLabel.includes('Akcept')">
                                        <cpc-icon icon='edit' color="#4D4D4D40" style="font-size: 20px"></cpc-icon>
                                    </td>
                                    <td nxTableCell *ngIf="!item.statusLabel.includes('Akcept')">
                                        <a (click)="editInsuredTrip(item.policyNumber)" r>
                                            <cpc-icon icon='edit' color="#007ab3" style="font-size: 20px"></cpc-icon>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                    <div nxRow>
                        <div nxCol="12">
                            <cpc-pagination [page]='activePage' [variant]="variant" [maxPage]='maxPage'
                                [itemsPerPage]='itemsPerPage' (changePage)='handleChangePage($event)'></cpc-pagination>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="12" class="generate-report">
                            <cpc-button size="small" [noHorizontalMargin]="true" [noVerticalMargin]="true"
                                (click)="reportModalShow('GenerateReport')"><span
                                    translate>policy.insured-trips.generate-report.title</span>
                            </cpc-button>
                        </div>
                    </div>
                </div>
            </nx-card>
        </div>
    </div>
</div>